import { Moment } from 'moment';
import moment from 'moment-timezone';
import 'moment/locale/es';

import { getLanguage, getTimezone } from '@utils/config';
import { RADIX_TEN } from '@utils/coupons';

moment.tz.setDefault(getTimezone());
moment.locale(getLanguage());
moment.updateLocale(getLanguage(), {
  months: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
});

const calculateExpirationTime = (validSeconds: string): number => Date.now() + parseInt(validSeconds, 10) * 1000 - 10;
const isExpired = (limit: string): boolean => Date.now() >= parseInt(limit, 10);

const parseToLongDate = (inputDate?: string, separator: string = ' ') => {
  const formatWithSeparator = `D${separator}MMMM${separator}YYYY`;
  return moment(inputDate)
    .tz(getTimezone())
    .format(formatWithSeparator)
    .replace(/\b\w/g, (l) => l.toUpperCase());
};
const getAvailableToRedeemDate = (inputDate?: string) => {
  const formatWithSeparator = 'D MMMM YYYY';
  const date = inputDate ?? moment();
  return moment(date)
    .tz(getTimezone())
    .add(72, 'hours')
    .format(formatWithSeparator)
    .replace(/\b\w/g, (l) => l.toUpperCase());
};

const getFinalRewardDateByDays = (days: number) => {
  const formatString = 'DD/MM/YYYY';

  return moment().tz(getTimezone()).add(days, 'days').format(formatString);
};

const getMonthByNumber = (number: string | number) => {
  switch (number) {
    case 1:
    case '1':
    case '01':
      return 'Enero';
    case 2:
    case '2':
    case '02':
      return 'Febrero';
    case 3:
    case '3':
    case '03':
      return 'Marzo';
    case 4:
    case '4':
    case '04':
      return 'Abril';
    case 5:
    case '5':
    case '05':
      return 'Mayo';
    case 6:
    case '6':
    case '06':
      return 'Junio';
    case 7:
    case '7':
    case '07':
      return 'Julio';
    case 8:
    case '8':
    case '08':
      return 'Agosto';
    case 9:
    case '9':
    case '09':
      return 'Septiembre';
    case 10:
    case '10':
      return 'Octubre';
    case 11:
    case '11':
      return 'Noviembre';
    case 12:
    case '12':
      return 'Diciembre';
    default:
      return null;
  }
};

const formatDateToWordingMonth = (date: string) => {
  const split = date.split('-');
  const day = parseInt(split[2], RADIX_TEN).toString();

  return `${day} ${getMonthByNumber(split[1])} ${split[0]}`;
};

const isMoreThanHour = (timestamp: number) => {
  return Date.now() - timestamp > 3600000;
};
const getDate = (inputDate: string, formatInput: string) => {
  return moment(inputDate, formatInput);
};
const getRedemptionIsoDate = (inputDate: Moment) => {
  const now = moment().utc().format('YYYY-MM-DD');
  const isTheSameDay = inputDate.isSame(now, 'day');

  return isTheSameDay ? moment().utc().format() : `${inputDate.format('YYYY-MM-DD')}T00:00:00+0000`;
};
const encryptDate = (date: string | null | undefined) => {
  if (!date) {
    return undefined;
  }

  if (date.length === 10) {
    const yearPart_1 = date.substr(0, 2);
    const yearPart_2 = date.substr(5, 2);
    const label = '**';
    const label_1 = '/';
    return label + label_1 + yearPart_2 + label_1 + yearPart_1 + label;
  }
  return date;
};

const parseDateQueryChild = (inputDate: string | null | undefined) => {
  const formatInput = `DD/MM/YYYY`;
  const formatWithSeparator = `YYYY-MM-DD`;

  if (!inputDate) return null;

  const date = moment(inputDate, formatInput, true);

  return date.isValid() ? date.format(formatWithSeparator) : null;
};
const parseDateQuery = (inputDate: string | null | undefined, format?: string) => {
  const date = moment(inputDate);
  const formatWithSeparator = format ?? 'YYYY-MM-DD';
  if (date.isValid()) {
    return date.format(formatWithSeparator);
  }
  return undefined;
};
export {
  calculateExpirationTime,
  isExpired,
  parseToLongDate,
  getAvailableToRedeemDate,
  formatDateToWordingMonth,
  isMoreThanHour,
  getDate,
  getRedemptionIsoDate,
  getFinalRewardDateByDays,
  encryptDate,
  parseDateQuery,
  parseDateQueryChild,
};
